<template>
    <div ref="container">
      <a-modal :title="title" :width="1400" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'200px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <slot></slot>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { ledgerAdd,ledgerEdit } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import product from '../product'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      JImageUpload,
      product
    },
    data() {
      return {
        title: '666',
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        
      }
    },
    created() {},
    methods: {
      initShow(e){
        this.visible = true
        // this.$refs.productLicenseModal.show(e)
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              ma: this.form.ma || '',
              company: this.form.company || '',
              legal: this.form.legal || '',
              credit: this.form.credit || '',
              capital: this.form.capital || '',
              reason: this.form.reason || '',
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await ledgerEdit(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.close()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            } else {
              const res = await ledgerAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.close()
              } else {
                this.$message.error(res.message)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
    },
  }
  </script>
  <style scoped>
  </style>